export const getAllWorkingStatusesEndpoint = 'working-statuses';
